module.exports = __webpack_public_path__ + "img/52d6ad4e2bb386f0d2be387477e2b82d.png";